// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2N10O","savePackageButton":"ClientWallet_savePackageButton__1-91G"};